/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import {addGrades,addUser} from 'actions/index';
import routes from "routes.js";
import { connect } from "react-redux";
import axios from 'axios';

function mapDispatchToProps(dispatch) {
  return {
    addGrades: grades => dispatch(addGrades(grades)),addUser: user => dispatch(addUser(user))
  };
}

const mapStateToProps = state => ({
  user: state.user
});

class Admin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      grades:[],
      user_role:'',
      user:{},
    };

    this.getGrades = this.getGrades.bind(this);
    this.attemptLogin = this.attemptLogin.bind(this);
  }

  componentDidMount(){    
    // //console.log("hitting props",this.props); 
    this.attemptLogin();    
  }


  attemptLogin(){
    // //console.log('attempting login');
   let is_logged_in = localStorage.getItem('isLoggedIn');
  //  //console.log('check',is_logged_in);
   if(is_logged_in){
    let is_logged_in = false;
    let cur = this;
        axios({
            headers: {
                'content-type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
            method: 'get',
            url: 'https://markerportalbackend.thinkdigitalacademy.org/api/user',
        }).then(res => {          
            is_logged_in = true;
            this.setState({user:res.data.user,user_role:res.data.user.roles[0].name});
            localStorage.setItem('userRole',res.data.user.roles[0].name);
            localStorage.setItem('user_id',res.data.user.id);
            this.props.addUser(res.data.user);
            this.getGrades();
        }).catch(error => {
          //console.log(error);
            let error_result = error.response;
            
            is_logged_in = false
        });
   }else{
    this.props.history.push('/auth');
   }
    
  }

  componentDidUpdate(e) {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;
  }

  getGrades() {
    // //console.log('getting grades');
    axios.get('https://admin.thinkdigitalacademy.org/api/marker-portal-get-grades').then(res=>{
          //console.log('grades',res.data);
         this.props.addGrades(res.data.grades);   
        //  //console.log('props',this.props.grades);   
         
      }).catch(error =>{
          // //console.log('error',error);
      });    
  }
  

  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "";
  };
  render() {
    return (
      <>
        <Sidebar
          {...this.props}
          routes={routes}
          logo={{
            innerLink: "/admin/index",
            imgSrc: require("assets/img/brand/logo_shrinking.png"),
            imgAlt: "..."
          }}
        />
        <div className="main-content" ref="mainContent">
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          <Switch>
            {this.getRoutes(routes)}
            {/* <Redirect from="*" to="/admin/index" /> */}
          </Switch>
          <Container fluid>
            <AdminFooter />
          </Container>
        </div>
      </>
    );
  }
}
export default connect(
  mapStateToProps,mapDispatchToProps
)(Admin);
